export default {
  totalCost: ' Цена после скидки',
  totalCost_num2str: ' Цена после скидки прописью',
  vat: 'НДС',
  vat_num2str: 'НДС прописью'
}
